var render = function render(){
  var _vm$actions$, _vm$actions$2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-inline-flex"
  }, [_c('v-btn', {
    staticClass: "action-menu-primary",
    attrs: {
      "color": _vm.color,
      "small": _vm.small,
      "dark": !_vm.outlined,
      "outlined": _vm.outlined,
      "disabled": _vm.disabled || _vm.loading,
      "loading": _vm.loading
    },
    on: {
      "click": _vm.triggerPrimaryAction
    }
  }, [(_vm$actions$ = _vm.actions[0]) !== null && _vm$actions$ !== void 0 && _vm$actions$.icon ? _c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v(_vm._s(_vm.actions[0].icon))]) : _vm._e(), _vm._v(" " + _vm._s((_vm$actions$2 = _vm.actions[0]) === null || _vm$actions$2 === void 0 ? void 0 : _vm$actions$2.label) + " ")], 1), _vm.actions.length > 1 ? _c('v-menu', {
    attrs: {
      "content-class": "compact-action-menu",
      "offset-y": "",
      "right": "",
      "transition": "scale-transition",
      "nudge-bottom": 5
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "action-menu-chevron px-0",
          attrs: {
            "color": _vm.color,
            "small": _vm.small,
            "dark": !_vm.outlined,
            "outlined": _vm.outlined,
            "disabled": _vm.disabled || _vm.loading,
            "aria-label": _vm.menuLabel,
            "min-width": "40"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)];
      }
    }], null, false, 2754936069),
    model: {
      value: _vm.menu,
      callback: function callback($$v) {
        _vm.menu = $$v;
      },
      expression: "menu"
    }
  }, [_c('v-list', _vm._l(_vm.actions, function (item, index) {
    return _c('v-list-item', {
      key: index,
      on: {
        "click": function click($event) {
          return _vm.onAction(item);
        }
      }
    }, [item.icon ? [_c('v-list-item-icon', [_c('v-icon', {
      attrs: {
        "color": item.color
      }
    }, [_vm._v(_vm._s(item.icon))])], 1)] : _vm._e(), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.label))])], 1)], 2);
  }), 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }